"use client";
import {
  useCollectionContext
} from "./KSMDNUGB.js";
import {
  createComponent,
  createElement,
  createHook
} from "./LFJDOMBA.js";
import {
  useId,
  useMergeRefs
} from "./6WEF4WY5.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./2SMRF6AD.js";

// src/collection/collection-item.ts
import { useEffect, useRef } from "react";
import { identity } from "@ariakit/core/utils/misc";
var useCollectionItem = createHook(
  (_a) => {
    var _b = _a, {
      store,
      shouldRegisterItem = true,
      getItem = identity,
      element: element
    } = _b, props = __objRest(_b, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const context = useCollectionContext();
    store = store || context;
    const id = useId(props.id);
    const ref = useRef(element);
    useEffect(() => {
      const element2 = ref.current;
      if (!id)
        return;
      if (!element2)
        return;
      if (!shouldRegisterItem)
        return;
      const item = getItem({ id, element: element2 });
      return store == null ? void 0 : store.renderItem(item);
    }, [id, shouldRegisterItem, getItem, store]);
    props = __spreadProps(__spreadValues({}, props), {
      ref: useMergeRefs(ref, props.ref)
    });
    return props;
  }
);
var CollectionItem = createComponent(
  (props) => {
    const htmlProps = useCollectionItem(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CollectionItem.displayName = "CollectionItem";
}

export {
  useCollectionItem,
  CollectionItem
};
